<template>
    <div class="modal-flexible-container">
        <b-row no-gutters class="h-100">
            <b-col cols="12" md="4" class="h-100 border-right scrollable-area">

                <!--b-form-group label="Пошук користувача" label-for="filter-input" class="mb-3">
                    <b-input-group-->
                        <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            placeholder="Введіть ім'я для пошуку..."
                        ></b-form-input>

                         <b-form-select
                            v-if="salepoints && Object.keys(salepoints).length > 1"
                            v-model="salepoint"
                        >
                            <b-form-select-option 
                                :key=null 
                                :value=null
                            >
                                Всі точки продажу
                            </b-form-select-option>

                            <template v-for="sp of  Object.keys(salepoints)">
                            <b-form-select-option 
                                :key="sp" 
                                :value="sp"
                            >
                                {{salepoints[sp]}}
                            </b-form-select-option>
                            </template>

                        </b-form-select>

                        <!--b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''"><b-icon icon="x"></b-icon></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group-->

                <b-table 
                    hover 
                    :items="(salepoint)?userlist.filter(s => s.srn==salepoint):userlist" 
                    :fields="fields"
                    sort-by="date"
                    :sort-desc="true" 
                    :filter="filter"
                    :filter-included-fields="['name']"
                    :busy="busy"
                    @row-clicked="openLog"
                    style="cursor: pointer;"
                    :tbody-tr-class="rowClass"
                >
                    <template #table-busy>
                        <div class="text-center text-dark my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Отримання списку...</strong>
                        </div>
                    </template>
                </b-table>
            </b-col>                
            <b-col md="8" class="h-100 d-none d-md-block scrollable-area scrollable-area-x">
                <div v-if="text" class="p-3">
                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <div class="p-2 h5 mr-auto">{{targetMnemo}}</div>
                        <div class="datenav">
                            <div>
                                <b-button
                                    v-if="dt && dtarr" 
                                    class="btn btn btn-victor border-bruvis" 
                                    @click = "dt=dtarr[dtarr.indexOf(dt)-1]"
                                    title="Попередній день"
                                    :disabled="dtarr.indexOf(dt)===0"
                                    >
                                    <b-icon 
                                        :variant="(dtarr.indexOf(dt)===0)?'secondary':''" 
                                        :icon="(dtarr.indexOf(dt)===0)?'caret-left':'caret-left-fill'">
                                    </b-icon>
                                </b-button>
                            </div>
                            <div class="h6 px-2">{{dt}}</div>
                            <div>
                                <b-button 
                                    v-if="dt && dtarr"
                                    class="btn btn-victor border-bruvis" 
                                    @click="dt=dtarr[dtarr.indexOf(dt)+1]" 
                                    title="Наступний день"
                                    :disabled="dtarr.indexOf(dt)===dtarr.length-1"
                                    >
                                    <b-icon 
                                        :variant="(dtarr.indexOf(dt)===dtarr.length-1)?'secondary':''" 
                                        :icon="(dtarr.indexOf(dt)===dtarr.length-1)?'caret-right':'caret-right-fill'">
                                    </b-icon>
                                </b-button>
                            </div>
                        </div>
                    </div>        
                    <b-overlay
                        :show="logbusy"
                        rounded
                        opacity="0.6"
                        spinner
                        spinner-variant="bruvis"
                    >
                        <template v-if="!dt || !datelog">
                            <pre v-html="text" class='log-viewer' @click="handleLogClick"></pre>
                        </template>
                        <template v-else>
                            <pre v-if="dt && datelog && datelog[dt]" v-html="datelog[dt]" class='log-viewer' @click="handleLogClick"></pre>
                        </template>    
                    </b-overlay>        
                </div>    
            </b-col>
        </b-row>

        <b-modal 
            v-model="showModal"
            id="logfile-modal" 
            size="lg"
            centered 
            modal-class="custom-full-height"
            scrollable 
            :no-close-on-backdrop="true" 
            ok-only
            ok-variant="bruvis"
            ok-title="Закрити"
            @hidden = "text = null,targetName=null,targetMnemo=null"
            >
            <template #modal-title>
                <b-icon icon="camera-reels-fill" class="rounded bg-bruvis p-1" variant="light" font-scale="1.3"></b-icon> 
                <template v-if="targetMnemo">
                    <span class="p-2 h5 mr-auto">Журнал {{targetMnemo}}</span>
                </template>
                <template v-else>
                    <span class="p-2 h5 mr-auto">Журнал {{targetName}}</span>
                </template>    
            </template>
            <template #modal-footer="{ ok }">
                <div class="w-100 d-flex justify-content-between align-items-center">
                    <div class="datenav" v-if="dt && dtarr">
                        <div>
                            <b-button
                                v-if="dt && dtarr" 
                                class="btn btn btn-victor border-bruvis" 
                                @click = "dt=dtarr[dtarr.indexOf(dt)-1]"
                                title="Попередній день"
                                :disabled="dtarr.indexOf(dt)===0"
                                >
                                <b-icon 
                                    :variant="(dtarr.indexOf(dt)===0)?'secondary':''" 
                                    :icon="(dtarr.indexOf(dt)===0)?'caret-left':'caret-left-fill'">
                                </b-icon>
                            </b-button>
                        </div>
                        <div class="h6 px-2">{{dt}}</div>
                        <div>
                            <b-button 
                                v-if="dt && dtarr"
                                class="btn btn-victor border-bruvis" 
                                @click="dt=dtarr[dtarr.indexOf(dt)+1]" 
                                title="Наступний день"
                                :disabled="dtarr.indexOf(dt)===dtarr.length-1"
                                >
                                <b-icon 
                                    :variant="(dtarr.indexOf(dt)===dtarr.length-1)?'secondary':''" 
                                    :icon="(dtarr.indexOf(dt)===dtarr.length-1)?'caret-right':'caret-right-fill'">
                                </b-icon>
                            </b-button>
                         </div>
                    </div>    

                    <div>
                        <b-button variant="bruvis" @click="ok()">
                            Закрити
                        </b-button>
                    </div>
                </div>
            </template>


            <b-overlay
                :show="logbusy"
                rounded
                opacity="0.6"
                spinner
                spinner-variant="bruvis"
            >
                <template v-if="!dt || !datelog">
                    <pre v-if="text" class="p-2 log-viewer" v-html="text" @click="handleLogClick"></pre>
                </template>
                <template v-else>
                    <pre v-if="dt && datelog && datelog[dt]" v-html="datelog[dt]" class='p-2 log-viewer' @click="handleLogClick"></pre>
                </template>
             </b-overlay>
            
        </b-modal>            

        <b-modal 
            v-model="showModal2"
            id="paylogfile-modal" 
            size="lg"
            centered 
            scrollable 
            :no-close-on-backdrop="true" 
            ok-only
            ok-variant="bruvis"
            ok-title="Закрити"
            @hidden = "paytext = null"
            >
            <template #modal-title>
                <b-icon icon="camera-reels-fill" class="rounded bg-bruvis p-1" variant="light" font-scale="1.3"></b-icon> 
                <span class="p-2 h5 mr-auto">Журнал платежу</span>
            </template>

             <b-overlay
                :show="logbusy"
                rounded
                opacity="0.6"
                spinner
                spinner-variant="bruvis"
            >
                <pre v-if="text" class="p-2 log-viewer" v-html="paytext" @click="handleLogClick"></pre>
             </b-overlay>
            
        </b-modal>            
    </div>
</template>

<script>

export default {
  name: 'LogFilesViewer',
  props: {
    
  },
  data: () => ({
    busy: false,
    logbusy: false,
    userlist: null,
    salepoints: null,
    salepoint: null,
    filter: null,
    selectedItem: null,
    showModal: false,
    showModal2: false,
    fields:[
        {key :'name',label:'User',sortable: true},
        {key :'date',label:'Last login',sortable: true}
    ],
    /*
    fields2:[
        {key :'mnemo',label:'User',sortable: true},
        {key :'date',label:'Last login',sortable: true}
    ],*/
    targetName: null,
    targetMnemo: null,
    text: null,
    datelog: null,
    dtarr: null,
    dt: null,
    paytext: null
  }),  
  methods: {

    getUserList(){
        this.busy = true
        this.$axios.post('', {"action":"getuserlist"})
            .then((res) => {
                this.busy = false  
                if(res.data.success != false && res.data.success != 'false'){
                    this.userlist = res.data.userlist
                    this.salepoints = res.data.salepoints
                    //this.$toasted.success('Список наявних логфайлів отримано').goAway(2000)
                }else{
                    if(res.data.error=="auth" || res.data.error=="tokenout"){
                        this.$emit('needlogin')
                    }else{
                        this.$toasted.error('Помилка отримання списку логфайлів').goAway(3000)
                        this.$toasted.error(res.data.error).goAway(3000)
                    }    
                }
                    
            })
            .catch(error => {
            console.error('There was an error!', error)
            });
    },
    openLog(item){
        this.logbusy = true
        this.targetName = item.name
        this.targetMnemo = item.mnemo
        if(!item.name) return
        //this.$bvModal.show('logfile-modal')
        this.$axios.post('', {"action":"getlog","rn":item.name})
            .then((res) => {
                this.logbusy = false  
                if(res.data.success != false && res.data.success != 'false'){
                    this.text = res.data.text
                    this.datelog = res.data.log
                    this.dtarr = Object.keys(this.datelog).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
                    this.dt = this.dtarr.at(-1)

                    if (window.innerWidth < 768) {
                        this.showModal = true;
                    }
                }else{
                    if(res.data.error=="auth" || res.data.error=="tokenout"){
                        this.$emit('needlogin')
                    }else{
                        this.text = 'Помилка'
                    }    
                }
                    
            })
            .catch(error => {
            console.error('There was an error!', error)
            });
    },
    openCallback(id){
        this.logbusy = true
        this.showModal2 = true;
        if(!id) return
        this.$axios.post('', {"action":"getpaylog","rn":id})
            .then((res) => {
                this.logbusy = false  
                if(res.data.success != false && res.data.success != 'false'){
                    this.paytext = res.data.text
                }else{
                    if(res.data.error=="auth" || res.data.error=="tokenout"){
                        this.$emit('needlogin')
                    }else{
                        this.paytext = 'Помилка'
                    }    
                }
            })
            .catch(error => {
               console.error('There was an error!', error)
            });
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.name === this.targetName) {
            return 'table-primary'
        }
    },
    handleLogClick(event) {
      const target = event.target.closest('.clickable-id');
      if (target) {
        const orderId = target.getAttribute('data-id');
        this.openCallback(orderId);
      }
    }
 
  },
  
  
  mounted() {
    this.getUserList()
  },

    computed: {
        
    }
}
</script>

<style scoped>

/* Убираем отступы у тела модалки, чтобы колонки прилегали к краям */
::v-deep .modal-body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
}

/* Контейнер должен занимать всю доступную высоту тела модалки */
.modal-flexible-container {
  height: calc(100vh - 120px); /* Вычитаем примерную высоту хедера модалки */
  min-height: 400px;
}

/* Обеспечиваем независимый скролл для каждой колонки */
.scrollable-area {
  overflow-y: auto;
  height: 100%;
}
.scrollable-area-x{
    overflow-x: auto;
}
pre{
    overflow: visible;
}
.datenav{
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Убираем общий скролл у модалки, если он вдруг появится */
::v-deep .modal-open .modal {
  overflow-y: hidden !important;
}

.cursor-pointer {
  cursor: pointer;
}


@media (max-width: 575px) {
  

}

@media (hover: none) {


}    

</style>

<style>

.log-viewer .clickable-id {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
}

</style>
